const value = {
  choice: {
    name: '',
    price: '0',
  },
};

export default value;
